var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 2.1a2.9 2.9 0 0 1 2.895 2.73L17.9 5v1.1H19a2.9 2.9 0 0 1 2.895 2.73L21.9 9v10a2.9 2.9 0 0 1-2.9 2.9H9A2.9 2.9 0 0 1 6.1 19v-1.1H5a2.9 2.9 0 0 1-2.895-2.73L2.1 15V5a2.893 2.893 0 0 1 2.73-2.895L5 2.1h10zm4 5.8H9A1.1 1.1 0 0 0 7.9 9v10A1.1 1.1 0 0 0 9 20.1h10a1.1 1.1 0 0 0 1.1-1.1V9A1.1 1.1 0 0 0 19 7.9zm-3.88-3.994L15 3.9H5c-.572 0-1.034.424-1.094.98L3.9 5v10a1.1 1.1 0 0 0 .98 1.094L5 16.1h1.1V9a2.9 2.9 0 0 1 2.73-2.895L9 6.1h7.1V5a1.1 1.1 0 0 0-.98-1.094z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCopy);
export default __webpack_public_path__ + "static/media/icons-copy.cb9ada981bd54cc058ca8a7d4d0034bd.svg";
export { ForwardRef as ReactComponent };